// frontend/src/pages/AgenteDettaglio.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AgenteForm from "./AgenteForm";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AgenteDettaglio() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/agenti/${id}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || "Errore caricamento agente");
        if (alive) setInitial(data);
      } catch (e) {
        if (alive) setErr(e.message);
      }
    })();
    return () => {
      alive = false;
    };
  }, [id]);

  if (err) return <div className="alert alert-danger">{err}</div>;
  if (!initial) return <div>Caricamento…</div>;

  return (
    <AgenteForm
      initial={initial}
      onSuccess={() => navigate("/agenti")}
    />
  );
}
